// import { LifeUserPolicies } from 'all-in-one-shared-api';
import { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from 'utils/isMobile';
import { isLocaleEnglish } from 'utils/languageUtils';
import { Row, Col, Grid, Divider, Select, Button, Modal, Typography } from 'antd';
import './PoliciesCorrespondence.less';
const { useBreakpoint } = Grid;
import styled from 'styled-components';
import {
  usePolicyCorrespondence,
  usePolicyDocCorrespondence,
  useLetterYear,
  useLetterType,
  // useClickDocument,
  useLifeDocumentDownLoad,
  usePolicyDocumentClickNew,
} from 'all-in-one-shared-api';
import axios from 'axios';
import { changeDataFun } from 'utils/formate';
// import { SvgXml } from 'react-native-svg';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import PDF from 'assets/images/policy/PDF.svg';
import { getConfig } from 'configs';
import { saveAs } from 'file-saver';
import { Spinner } from 'components';
import Close from 'assets/images/liHome/close.svg';
import { useNavigate } from 'react-router-dom';

interface PvLocationState {
  policyNo?: string;
  companyCode?: string;
  salesUnitCode?: string;
}
type PolicyDetailProps = {
  pValues: PvLocationState;
};
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  // background: #fff;
  margin-bottom: 1rem;
`;

const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 16px;
`;
export interface PolicyCorrespondenceDaum {
  letterType: string;
  letterTypeDesc: string;
  letterTypeDescTc: string;
  letterDate: string;
  docUrl: string;
}
const PolicyDetail = ({ pValues }: PolicyDetailProps) => {
  const { t, i18n } = useTranslation();
  const UserAgent = navigator.userAgent;
  // const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(UserAgent);
  const isMobile = isMobileDevice(UserAgent);
  const isEnglish = isLocaleEnglish(i18n.language);
  const { token } = useKeycloakReady();
  const { lg, xs } = useBreakpoint();
  const [firstFlag, setFirstFlag] = useState(false);
  const [viewMore, setViewMore] = useState({
    page: 0,
    pageSize: 5,
  });
  const { Title } = Typography;
  const [showModalTips, setShowModalTips] = useState(false);

  const { baseApiUrl } = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'development');
  const [yearsData, setYearsData] = useState((): { label: string; value: string }[] => []);
  const [letterTypeData, setLetterTypeData] = useState((): { label: string; value: string }[] => []);
  // const [year, setYear] = useState(isLocaleEnglish(i18n.language) ? 'Select Year' : '選擇年份');
  // const [type, setType] = useState(isLocaleEnglish(i18n.language) ? 'Select document type' : '選擇文件類型');
  const [year, setYear] = useState('');
  const [type, setType] = useState('');
  const [doc2Datas, setDoc2Datas] = useState((): PolicyCorrespondenceDaum[] => []);
  const [clickMore, setClickMore] = useState(false);
  const [moreExist, setMoreExist] = useState(false);
  const [clickFlag, setClickFlag] = useState<string>();
  const [randoms, setRandoms] = useState(0);
  const [docUri, setDocUri] = useState('');
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const [filename, setFilename] = useState('');
  const previewUrl = `${baseApiUrl}/xapi/v1/life-user/policy-document-preview`;
  const navigate = useNavigate();

  const {
    shouldFetch: docFetch,
    data: docData,
    error: docError,
  } = usePolicyDocCorrespondence(
    'usePolicyDocCorrespondence',
    token ?? '',
    pValues.policyNo ?? '',
    pValues.companyCode ?? '',
    '',
    '',
  );

  const {
    shouldFetch: policyCorrFetch,
    data: policyCorrFetchData,
    error: policyCorrFetchError,
  } = usePolicyCorrespondence(
    'usePolicyCorrespondence' + randoms,
    token ?? '',
    pValues.policyNo ?? '',
    pValues.companyCode ?? '',
    year === 'All years' ? '' : year,
    type === 'All documents' ? '' : type,
    viewMore.page,
    viewMore.pageSize,
    {
      onSuccess: (res) => {
        setStartLoading(false);
        if (res && clickMore) {
          policyCorrFetch(false);
          setClickMore(false);
          setDoc2Datas(doc2Datas.concat(res));
        } else if (res && !clickMore) {
          policyCorrFetch(false);
          setClickMore(false);
          setDoc2Datas(res);
        }
        if (res && res?.length < 5) {
          setMoreExist(false);
        } else if (res?.length == 5) {
          if (res[0]?.pageFlag == 'N') setMoreExist(false);
          else setMoreExist(true);
        }
      },
      onError: () => {
        setStartLoading(false);
      },
    },
  );
  const { shouldFetch: yearFetch, data: yearData } = useLetterYear(
    'useLetterYear',
    token ?? '',
    pValues.policyNo ?? '',
    pValues.companyCode ?? '',
  );
  const { shouldFetch: letterFetch, data: letterData } = useLetterType(
    'useLetterType',
    token ?? '',
    pValues.policyNo,
    pValues.companyCode,
  );
  const { shouldFetch: shouleFetchClick } = usePolicyDocumentClickNew(
    'useClickDocument',
    token ?? '',
    pValues.policyNo ?? '',
    pValues.companyCode ?? '',
    {
      shouldRetryOnError: false,
      onSuccess: async (res) => {
        shouleFetchClick(false);
        console.log('res-----------------------------------------', res);
        if (!isMobile) {
          const file = await axios({
            method: 'get',
            url: previewUrl,
            params: {
              fileFullPath: docUri,
            },
            headers: { Authorization: 'Bearer ' + token },
            responseType: 'blob',
          });
          if (file) {
            setStartLoading(false);
          }
          const link = document.createElement('a');
          const url = URL.createObjectURL(file.data);
          link.href = url;
          link.target = '_blank';
          link.rel = 'noreferrer';
          // if (file.data.size >= 10 * 1024 * 1024) link.download = filename + '.pdf';
          document.body.appendChild(link);
          // link.click();
          const e = document.createEvent('MouseEvent');
          e.initEvent('click', false, false);
          link.dispatchEvent(e);
        } else {
          setRandoms(Math.random());
          shouldFetch(true);
        }
      },
      onError: (err) => {
        console.log(err.code, 'ooooooooooooooooooooooooooooooooooooouuuuuuuuuuu');
        shouleFetchClick(false);
        navigate('/ChangeRequestError', {
          replace: true,
        });
      },
    },
  );
  const {
    // data: downloadData,
    shouldFetch,
  } = useLifeDocumentDownLoad({
    key: 'useLifeDocumentDownLoad' + randoms,
    accessToken: token ?? '',
    uri: docUri,
    config: {
      onSuccess: async (res) => {
        const file = new File([res as unknown as BlobPart], `${filename}.pdf`, {
          type: 'application/pdf',
        });
        saveAs(file);
        setStartLoading(false);
      },
      onError: () => {
        setStartLoading(false);
      },
    },
  });
  const handleChange = (value: string) => {
    console.log(`selected ${value}`);
    setStartLoading(true);
    setFirstFlag(false);
    setYear(value);
  };
  const handleChangeType = (value: string) => {
    console.log(`selected ${value}`);
    setStartLoading(true);
    setFirstFlag(false);
    setType(value);
  };
  useEffect(() => {
    // console.log(clickMore, policyCorrFetchData, 1111111111);
    // if (policyCorrFetchData && clickMore) {
    //   policyCorrFetch(false);
    //   setClickMore(false);
    //   setDoc2Datas(doc2Datas.concat(policyCorrFetchData));
    // } else if (policyCorrFetchData && !clickMore) {
    //   policyCorrFetch(false);
    //   setClickMore(false);
    //   setDoc2Datas(policyCorrFetchData);
    // } else
    if (policyCorrFetchError) {
      setMoreExist(false);
      setClickMore(false);
    }
    // if (policyCorrFetchData && policyCorrFetchData?.length < 5) {
    //   setMoreExist(false);
    // } else if (policyCorrFetchData?.length == 5) {
    //   setMoreExist(true);
    // }
  }, [policyCorrFetchData, policyCorrFetchError, clickMore, doc2Datas, policyCorrFetch]);
  const toViewMore = () => {
    setViewMore({
      ...viewMore,
      page: viewMore.page + 1,
    });
    setClickMore(true);
    setRandoms(Math.random());
    setFirstFlag(false);
    policyCorrFetch(true);
  };
  useEffect(() => {
    setStartLoading(true);
    if (!pValues) return;
    docFetch(true);
    yearFetch(true);
    setFirstFlag(true);
    letterFetch(true);
  }, [docFetch, pValues, yearFetch, letterFetch]);
  useEffect(() => {
    setStartLoading(true);
    setViewMore({
      ...viewMore,
      page: 0,
    });
    setRandoms(Math.random());
    policyCorrFetch(true);
    // eslint-disable-next-line
  }, [year, type, policyCorrFetch]);
  useEffect(() => {
    if (docData) {
      setClickFlag(docData.hiddenNewPolIssAlertFlag);
    }
  }, [docData, docError]);
  useEffect(() => {
    if (letterData) {
      setLetterTypeData(
        [
          {
            label: isEnglish ? 'All documents' : '所有文件',
            value: 'All documents',
          },
        ].concat(
          letterData.map((d) => {
            return {
              label: isEnglish ? d.description : d.descriptionTc,
              value: d.description,
            };
          }),
        ),
      );
    }
  }, [letterData, isEnglish]);
  useEffect(() => {
    if (yearData) {
      setYearsData(
        [
          {
            label: isEnglish ? 'All years' : '所有年份',
            value: 'All years',
          },
        ].concat(
          yearData.selectYear.map((d) => {
            return {
              label: d,
              value: d,
            };
          }),
        ),
      );
    }
  }, [yearData, isEnglish]);

  const handleConfirm = async () => {
    setShowModalTips(false);
    setClickFlag('N');
    shouleFetchClick(true);
  };

  const pdfDetail = async (doc: string, filename: string) => {
    setStartLoading(true);
    setDocUri(doc);
    setFilename(filename);
    if (!isMobile) {
      const file = await axios({
        method: 'get',
        url: previewUrl,
        params: {
          fileFullPath: doc,
        },
        headers: { Authorization: 'Bearer ' + token },
        responseType: 'blob',
      });
      if (file) {
        setStartLoading(false);
      }
      const link = document.createElement('a');
      const url = URL.createObjectURL(file.data);
      link.href = url;
      link.target = '_blank';
      link.rel = 'noreferrer';
      // if (file.data.size >= 10 * 1024 * 1024) link.download = filename + '.pdf';
      document.body.appendChild(link);
      // link.click();
      const e = document.createEvent('MouseEvent');
      e.initEvent('click', false, false);
      link.dispatchEvent(e);
    } else {
      setRandoms(Math.random());
      shouldFetch(true);
    }
  };
  const previewPdf = async (doc: string, filename: string) => {
    setStartLoading(true);
    setDocUri(doc);
    setFilename(filename);
    if (clickFlag == 'Y') {
      setShowModalTips(true);
    } else {
      pdfDetail(doc, filename);
    }

    // URL.revokeObjectURL(url);
  };

  const testpolicy = (num?: string) => {
    return num ? num.startsWith('28') : false;
  };

  return (
    <div className="policies-correspondence-wrap" style={{ position: 'relative' }}>
      {startLoading && (
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      )}
      <StyledBlock className="base-detail">
        <div className="adjust-content" style={{ backgroundColor: lg ? 'transparent' : '#fff' }}>
          <Androw justify="start" paddingFlag={lg ? '40px' : '16px'} style={{ marginBottom: lg ? '24px' : 0 }}>
            {!(pValues.salesUnitCode == 'ZAL' || testpolicy(pValues.policyNo)) && docData?.correspondenceDate && (
              <>
                <AndCol className="font-setting500 font-size17 grey-font ">
                  {t('life.policies.PolicyDocumentCorrespondence', {
                    date: isEnglish ? docData?.correspondenceDate : changeDataFun(docData?.correspondenceDate),
                  })}
                </AndCol>
                {!lg && <Divider style={{ margin: '16px 0' }}></Divider>}
              </>
            )}
          </Androw>
          {docData?.policyDocumentData &&
            docData?.policyDocumentData.length > 0 &&
            Object.keys(docData?.policyDocumentData[0]).length > 0 && (
              <div className="value-content">
                <Androw justify="start" align="middle" className="background" paddingFlag={lg ? '25px' : '0'}>
                  <AndCol style={{ width: '100%' }} className="font-size26 title grey-font">
                    {t('life.policies.PolicyDocument')}
                  </AndCol>
                  <Divider style={{ margin: '16px 0' }}></Divider>

                  {docData?.policyDocumentData.map((doc, index) => (
                    <Col
                      key={index}
                      style={{ width: '100%', cursor: 'pointer' }}
                      onClick={() => previewPdf(doc.docUrl, isEnglish ? doc.docTypeDesc : doc.docTypeDescTc)}
                    >
                      <Androw
                        justify="space-between"
                        align="middle"
                        style={{ maxHeight: '83px', paddingBottom: '20px' }}
                        className="background"
                      >
                        <AndCol style={{ display: 'flex' }}>
                          <img src={PDF} alt="" />
                          {/* </AndCol>
                      <AndCol> */}
                          <div style={{ marginLeft: '4px' }}>
                            <p
                              className="p-bottom font-setting500 font-size15 grey-font"
                              style={{ marginBottom: '8px' }}
                            >
                              {isEnglish ? doc.docDate : changeDataFun(doc.docDate)}
                            </p>
                            <p className="p-bottom font-size17">{isEnglish ? doc.docTypeDesc : doc.docTypeDescTc}</p>
                          </div>
                        </AndCol>
                        <AndCol span={1}>
                          <img src={ChevronRight} alt="" />
                        </AndCol>
                      </Androw>
                    </Col>
                  ))}
                </Androw>
              </div>
            )}
        </div>
      </StyledBlock>

      {!(doc2Datas.length == 0 && firstFlag) && (
        <>
          <StyledBlock className="base-detail">
            <div
              className="adjust-content"
              style={{
                backgroundColor: '#fff',
                width: lg ? '672px' : '100%',
                margin: '0 auto',
                borderBottom: lg ? '1px solid #ccc' : 0,
                height: '70px',
              }}
            >
              <div className="value-content" style={{ height: '100%' }}>
                <Androw justify="start" align="middle" style={{ marginBottom: lg ? '24px' : 0, height: '100%' }}>
                  <AndCol className="font-setting500 font-size22 grey-font ">
                    {t('life.policies.PolicyCorrespondenceTitle')}
                  </AndCol>
                </Androw>
              </div>
            </div>
          </StyledBlock>
          <StyledBlock className="base-detail">
            <Androw
              justify="start"
              align="middle"
              className="select-wrap"
              style={{ marginBottom: lg ? '24px' : 0, height: '100%', backgroundColor: '#fff' }}
            >
              <AndCol className="font-setting500 font-size22 grey-font ">
                <Select
                  placeholder={isEnglish ? 'Select Year' : '選擇年份'}
                  style={{ width: '100%', height: '100%' }}
                  onChange={handleChange}
                  value={year ? year : undefined}
                  options={yearsData}
                />
              </AndCol>
            </Androw>
          </StyledBlock>
          <StyledBlock className="base-detail">
            <Androw
              justify="start"
              align="middle"
              className="select-wrap"
              style={{ marginBottom: lg ? '24px' : 0, height: '100%', backgroundColor: '#fff' }}
            >
              <AndCol className="font-setting500 font-size22 grey-font ">
                <Select
                  placeholder={isEnglish ? 'Select document type' : '選擇文件類型'}
                  style={{ width: '100%', height: '100%' }}
                  onChange={handleChangeType}
                  options={letterTypeData}
                  value={type ? type : undefined}
                />
              </AndCol>
            </Androw>
          </StyledBlock>
          <StyledBlock className="base-detail">
            <div className="adjust-content" style={{ backgroundColor: lg ? 'transparent' : '#fff' }}>
              <div className="value-content">
                <Androw justify="start" align="middle" className="background">
                  {doc2Datas.map((policyCorr, index) => (
                    <Col
                      key={index}
                      style={{ width: '100%', cursor: 'pointer' }}
                      onClick={() =>
                        pdfDetail(
                          policyCorr.docUrl,
                          isEnglish ? policyCorr.letterTypeDesc : policyCorr.letterTypeDescTc,
                        )
                      }
                    >
                      <Androw
                        justify="space-between"
                        align="middle"
                        style={{ minHeight: '60px' }}
                        className="background"
                      >
                        <AndCol style={{ display: 'flex' }} span={18}>
                          <img src={PDF} alt="" />
                          {/* </AndCol>
                      <AndCol> */}
                          <div style={{ marginLeft: '4px' }}>
                            <p
                              className="p-bottom font-setting500 font-size15 letter-space4 grey-font"
                              style={{ marginBottom: '8px' }}
                            >
                              {isEnglish ? policyCorr.letterDate : changeDataFun(policyCorr.letterDate)}
                            </p>
                            <p className="p-bottom font-size17 letter-space4 ">
                              {isEnglish ? policyCorr.letterTypeDesc : policyCorr.letterTypeDescTc}
                            </p>
                          </div>
                        </AndCol>
                        <AndCol span={1}>
                          <img src={ChevronRight} alt="" />
                        </AndCol>
                      </Androw>
                    </Col>
                  ))}
                  {moreExist && (
                    <Button className="view-more font-size17 red-font" onClick={toViewMore}>
                      {isEnglish ? 'View more' : '查閱更多'}
                    </Button>
                  )}
                </Androw>
              </div>
            </div>
          </StyledBlock>
        </>
      )}
      <Modal
        okText={t('life.policies.policydocY')}
        cancelText={t('life.policies.policydocN')}
        open={showModalTips}
        onCancel={() => {
          setShowModalTips(false);
          setStartLoading(false);
        }}
        className="e-notice-modal"
        width={xs ? 'calc(100% - 32px)' : '510px'}
        closeIcon={<img src={Close} />}
        onOk={handleConfirm}
      >
        <div>
          <Title level={5} className={`red-font ${lg ? 'font-size26' : 'font-size22'}`}>
            {t('life.policies.policydocClickTitle')}
          </Title>
        </div>
      </Modal>
    </div>
  );
};
export default PolicyDetail;
